import { motion } from "@smartsheet/design-tokens";
import { themed } from "../../../util/theme";

export const chipTheme = themed({
    borderRadius: {
        "lodestar-light": "2px",
        "ursa-light": "6px",
    },
    height: {
        medium: "28px",
        small: "24px",
    },
    showIcon: {
        "lodestar-light": false,
        "ursa-light": true,
    },
    motion: {
        animation: {
            "lodestar-light": "",
            "ursa-light": `background-color ${motion.animation.default}`,
        },
    },
});
